import { oneMinute } from 'app/features/conversations/Hooks/useElapsedTimeFromNow';
import {
  IConversationUnreadCount,
  useLazyGetUnreadMessagesCountQuery,
} from 'app/services/messages/getUnreadMessagesCount';
import { createContext, useContext, useEffect } from 'react';
import { useAuth } from './AuthProvider';
export const ConversationsNotificationContext = createContext<{
  unreadConversations?: IConversationUnreadCount[];
  unreadCount?: number;
  getUnreadMessagesCount: () => void;
  isLoadingUnreadCount?: boolean;
}>({ getUnreadMessagesCount: () => {} });

export const useUnreadConversations = () =>
  useContext(ConversationsNotificationContext);

export default function ConversationsNotificationsProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { user } = useAuth();
  const [
    getUnreadMessagesCount,
    { data, isLoading: isLoadingUnreadCount, isSuccess },
  ] = useLazyGetUnreadMessagesCountQuery({
    pollingInterval: oneMinute,
  });

  useEffect(() => {
    if (!user) return;
    getUnreadMessagesCount();
  }, [user]);

  const { authentication } = useAuth();

  return (
    <ConversationsNotificationContext.Provider
      value={{
        unreadCount: data?.total_count,
        isLoadingUnreadCount,
        getUnreadMessagesCount,
        unreadConversations: data?.data,
      }}
    >
      {children}
    </ConversationsNotificationContext.Provider>
  );
}
